import { NgModule } from '@angular/core';
import { VehicleSearchService } from '../../../../vehicle/search/vehicle-search/vehicle-search.service';
import { CommonModule } from '@angular/common';
import { VehicleGenericSearchComponent } from './vehicle-generic-search.component';
import { VehicleGenericBaseModule } from '../vehicle-generic-base/vehicle-generic-base.module';

@NgModule({
    declarations: [
        VehicleGenericSearchComponent
    ],
    providers: [
        VehicleSearchService
    ],
    imports: [
        CommonModule,
        VehicleGenericBaseModule
    ],
    exports: [
        VehicleGenericSearchComponent
    ]
})

export class VehicleGenericSearchModule {
}
